import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import useMenuDropUp from "../../../../hooks/useMenuDropUp";
import ExerciseInsertMenuItems from "../../../../parts/menus/ExerciseInsertMenuItems";
import SvgIcon from "../../../../parts/SvgIcon";
import {
  RillContext,
  useRillContext,
} from "../../../../rill/RillReact/share/base";

const DayExerciseOptions = ({ activeExercise, handleDuplicate }) => {
  const { t } = useTranslation("dashboard");
  const {
    locals: { query },
  } = useRillContext();
  const [opened, setOpened] = useState(false);
  const detailsRef = useRef(null);
  const dropUp = useMenuDropUp(detailsRef, opened);
  const isMetcon = activeExercise.primary === "metcon";

  return (
    <div className="more ml-1">
      <details ref={detailsRef} role="list" open={opened}>
        <summary
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpened(!opened);
          }}
          onBlur={(e) => {
            if (!e.relatedTarget || !e.relatedTarget.role === "listbox") {
              e.preventDefault();
              setOpened(false);
            }
          }}
          aria-haspopup="listbox"
          className="p-0! h-auto!"
        >
          <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
        </summary>
        <ul
          role="listbox"
          className={`exercise-menu${opened ? " opened" : ""}${dropUp ? " drop-up" : ""}`}
          tabIndex="-1"
        >
          <ExerciseInsertMenuItems
            activeExercise={activeExercise}
            day={query.date || query.day}
            onSelect={() => setOpened(false)}
          />
          {activeExercise.cycle && !isMetcon && (
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                submit("/actions/refresh?", {
                  method: "GET",
                  body: {
                    "modal[type]": "progression",
                    exerciseId: activeExercise._id,
                    type: "exercise",
                  },
                });
              }}
            >
              <a>{t("calendar.dayExerciseOptions.progression")}</a>
            </li>
          )}
          {!activeExercise.complex && (
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                handleDuplicate(activeExercise);
              }}
            >
              <a>{t("calendar.dayExerciseOptions.duplicate")}</a>
            </li>
          )}
          <li
            onClick={(e) => {
              e.stopPropagation();
              setOpened(false);
              const body = {
                "modal[type]": "calendar-add-exercise",
                day: query.date || query.day,
                exercise: activeExercise._id,
                editMode: true,
              };
              // Complexes open in Edit Workout with the rest of the workout
              // (sc-47391); point it at a saved member of the complex.
              if (activeExercise.complex && activeExercise.exercises?.length) {
                body.exercise = activeExercise.exercises[0]._id;
              }
              if (isMetcon) {
                body.addType = "metcon";
              }
              submit("/actions/refresh?", {
                method: "GET",
                body,
              });
            }}
          >
            <a>{t("calendar.dayExerciseOptions.edit")}</a>
          </li>
          {!activeExercise.complex && !isMetcon && (
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                submit("/actions/refresh?", {
                  method: "GET",
                  body: {
                    "modal[type]": "swap-exercise",
                    exercise: activeExercise._id,
                    editMode: true,
                  },
                });
              }}
            >
              <a>{t("calendar.dayExerciseOptions.swap")}</a>
            </li>
          )}
          <li
            onClick={(e) => {
              e.stopPropagation();
              setOpened(false);
              if (activeExercise.complex && activeExercise.exercises) {
                submit("/actions/complex/remove", {
                  method: "POST",
                  body: {
                    exercises: activeExercise.exercises,
                  },
                });
              } else {
                submit(`/actions/exercise/remove/${activeExercise._id}`, {
                  method: "GET",
                  body: {
                    proxyAthlete: query.athlete,
                  },
                });
              }
            }}
          >
            <a>{t("calendar.dayExerciseOptions.delete")}</a>
          </li>
        </ul>
      </details>
    </div>
  );
};

export default DayExerciseOptions;
